module.exports = __webpack_public_path__ + "assets/WP-logo-transparent.1c762f944b796de2539faf74457b1948.png";